function createKeyPressHandlers(handler, keyCode) {
  for (var _len = arguments.length, keys = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    keys[_key - 2] = arguments[_key];
  }

  return function (event) {
    // keyCode and which are deprecated, we have it for legacy reason
    if (keys.includes(event.key) || event.keyCode === keyCode || event.which === keyCode) {
      handler(event);
    }
  };
}

function emulateClick(elementRef) {
  if (elementRef && elementRef.current && typeof elementRef.current.click === 'function') {
    // elementRef.current.click()
    elementRef.current.dispatchEvent(new Event('click'));
  }
}

function createClickOnEnterHandler(elementRef) {
  return createKeyPressHandlers(function () {
    return emulateClick(elementRef);
  }, 13, 'Enter');
}

function createClickOnSpaceHandler(elementRef) {
  return createKeyPressHandlers(function () {
    return emulateClick(elementRef);
  }, 32, ' ', 'Spacebar');
}

export { createClickOnEnterHandler, createClickOnSpaceHandler, createKeyPressHandlers };